import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { NavController } from '@ionic/angular';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { LocationService } from '../../location/location.service';
import { EmployeeService } from '../../employee/logic/employee.service';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { BusinessTripEventRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/btrip-events-remote-action-builder/btrip-events-remoteaction-builder';
import { BusinessTripEventRemoteActionType } from 'src/app/_model/remote-action/remote-action-builder/btrip-events-remote-action-builder/btrip-events-remote-action-type';

@Injectable({
  providedIn: 'root',
})
export class EndOfSteeringPauseActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'eosp';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialsService: CredentialsService,
    private navigationController: NavController,
    private clientStateService: ClientStateService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private locationService: LocationService,
    private employeeService: EmployeeService,
    private appParameterService: AppParameterService,
    private zone: NgZone
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.remoteActionBuilderService.newBuild(
      new BusinessTripEventRemoteActionBuilder(
        BusinessTripEventRemoteActionType.END_OF_STEERING_PAUSE,
        this.clientStateService,
        this.appService,
        this.credentialsService,
        this.locationService,
        this.employeeService,
        this.appParameterService,
        this.logger
      )
    );
    this.zone.run(() => {
      this.navigationController.navigateForward('/feature/remote-action');
    });
  }

  // Private Functions
}
